import { render, staticRenderFns } from "./RenameModal.vue?vue&type=template&id=02dae6e8"
import script from "./RenameModal.vue?vue&type=script&lang=js"
export * from "./RenameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02dae6e8')) {
      api.createRecord('02dae6e8', component.options)
    } else {
      api.reload('02dae6e8', component.options)
    }
    module.hot.accept("./RenameModal.vue?vue&type=template&id=02dae6e8", function () {
      api.rerender('02dae6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/RenameModal.vue"
export default component.exports